import React from "react";

export const MenuDots = React.forwardRef<SVGSVGElement, React.SVGAttributes<SVGElement>>(function MenuDots(props, ref) {
	return (
		<svg ref={ref} fill="#fff" {...props}>
			<use xlinkHref="#icon-menu_dots"></use>
		</svg>
	);
});
